module.exports = __webpack_public_path__ + "static/media/ppt.0d895819.png";